import { Link } from "react-router-dom";
import { MessageCircle, ArrowRight, CheckCircle2, Sparkles } from "lucide-react";

const FEATURES = [
  "Register and complete your profile",
  "Describe your business idea by voice or text",
  "Request a free valuation",
  "Upload documents (receipts, invoices, photos)",
  "Browse and save opportunities",
  "Receive investor and buyer matches",
  "Get instant AI-powered answers 24/7",
];

export default function WhatsAppPage() {
  return (
    <div data-testid="whatsapp-page" className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="dv-pill mb-4 bg-emerald-50 text-emerald-700"><Sparkles size={13} /> Coming soon</span>
          <h1 className="dv-display text-4xl md:text-6xl leading-tight mb-5">DealVest, on WhatsApp.</h1>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed">
            Built for emerging markets. Register, list your business, request a valuation, get investor matches, and chat with our AI advisor — all from WhatsApp.
            <br /><br />
            <span className="text-slate-700 font-medium">No app to download. Works on any phone.</span>
          </p>
          <ul className="space-y-3 mb-10">
            {FEATURES.map((f, i) => (
              <li key={i} className="flex items-start gap-3 text-slate-700">
                <CheckCircle2 size={18} className="text-emerald-500 flex-shrink-0 mt-0.5" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <Link to="/signup" className="dv-btn dv-btn-primary" data-testid="whatsapp-cta">
            Sign up to get notified <ArrowRight size={16} />
          </Link>
          <p className="text-sm text-slate-500 mt-4">We'll WhatsApp you the moment our bot goes live.</p>
        </div>
        <div className="relative max-w-md mx-auto">
          <div className="bg-emerald-500 rounded-[36px] p-4 shadow-2xl shadow-emerald-200">
            <div className="bg-white rounded-[28px] overflow-hidden">
              <div className="bg-emerald-500 text-white px-5 py-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-emerald-600 font-bold">D</div>
                <div>
                  <div className="font-semibold">DealVest AI</div>
                  <div className="text-xs text-emerald-100">online · responds in seconds</div>
                </div>
              </div>
              <div className="p-5 space-y-3 bg-[#ECE5DD] min-h-[400px] text-sm">
                <div className="bg-white rounded-2xl rounded-tl-md px-3 py-2 max-w-[85%] shadow-sm">
                  <p>Hi 👋 I'm DealVest AI. What would you like to do today?</p>
                  <p className="mt-2 text-slate-600 text-xs">1. Sell my business<br />2. Buy a business<br />3. Raise capital<br />4. Free valuation</p>
                </div>
                <div className="bg-emerald-100 rounded-2xl rounded-tr-md px-3 py-2 max-w-[80%] ml-auto shadow-sm">
                  <p>I want to sell my farm in Kenya</p>
                </div>
                <div className="bg-white rounded-2xl rounded-tl-md px-3 py-2 max-w-[85%] shadow-sm">
                  <p>Great! Tell me about your farm — by voice or text. Size, crops, annual revenue, location?</p>
                </div>
                <div className="bg-emerald-100 rounded-2xl rounded-tr-md px-3 py-2 max-w-[60%] ml-auto shadow-sm flex items-center gap-2">
                  <span>🎤</span> <span className="text-xs text-slate-600">Voice note · 0:42</span>
                </div>
                <div className="bg-white rounded-2xl rounded-tl-md px-3 py-2 max-w-[85%] shadow-sm">
                  <p>Got it. Estimated value: <span className="font-bold text-emerald-600">$180K–$240K</span>. I'll match you with 3 buyers in your region. Want to proceed?</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
